import styled from '@emotion/styled';
import { hideVisually } from 'polished';

const Anchor = styled.a<{ $showText: boolean }>`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  color: inherit;
  text-decoration: inherit;

  &:focus-visible {
    border-radius: ${({ theme, $showText }) =>
      $showText ? theme.borderRadius.md : '100%'};
    outline: 0.125rem dashed ${({ theme }) => theme.color.secondary};
    outline-offset: 0.25rem;
  }
`;

const Text = styled.span<{ $showText: boolean }>`
  ${({ $showText }) => ($showText ? undefined : hideVisually())};
`;

export { Anchor, Text };
